export default {
    nav: {
        dashboard: "Dashboard",
        index: "Notification",
        message: "Message",
        phone: "Phone",
        email: "Email",
        wechat: "WeChat",
    },

    message: {
        all: "All",

        toolbar: {
            back: "Back",
            refresh: "Refresh",
            read_config: "Mark as Read",
            delete: "Delete",
            read: "Read",
            unread: "Unread",
            normal: "Normal",
            important: "Important",
            urgent: "Urgent",
            previous: "Previous",
            next: "Next",
            search: "Search",
        },

        table: {
            detail: "Details",
            remark: "Remark",
            remark_placeholder: "Please enter a remark",
            link: "Link",
            del_mul_message: "Are you sure you want to delete the selected messages?",
            del_message: "Are you sure you want to delete this message?",
            no_data: "No Data Available",
        },

        time: {
            today: "Today",
            saturday: "Saturday",
            friday: "Friday",
            thursday: "Thursday",
            wednesday: "Wednesday",
            tuesday: "Tuesday",
            monday: "Monday",
            last: "Last Week",
            earlier: "Earlier",
        },

        meta: {
            link: "Link",
            misc: "Misc",
        },
    },

    phone: {
        bindPhone: "Bind Phone",
        bindPhoneAlert: "Bind your phone to receive notifications",
        currentBind: "Current",
        noBind: "- None -",
        sameError: "The two bindings cannot be the same",
        number: "Phone Number",
        code: "Code",
        send: "Send Code",
        sendSuccess: "Code Sent Successfully",
        confirm: "Confirm",
        numberPlaceholder: "Please enter your phone number",
        numberError: "Please enter a valid phone number",
        codePlaceholder: "Please enter the verification code",
        codeError: "Please enter the correct verification code",
    },

    email: {
        address: "Email",
        bindEmail: "Bind Email",
        bindEmailAlert: "Bind your email to receive notifications",
        currentBind: "Current",
        noBind: "- None -",
        sameError: "The two bindings cannot be the same",
        sendEmailSuccess:
            "A verification email has been sent to your email {email}, click the verification link to bind successfully! The email is valid for 7 days.",
        verifyContent: `<h1>Waiting for Verification</h1><div>Please click on the verification link sent to your email address (<b>{url}</b>) to complete the verification.<br>This link is valid for 7 days; if exceeded, you will need to resubmit the verification request.</div>`,
        addressPlaceholder: "Please enter your email address",
        addressError: "Please enter a valid email address",
        codePlaceholder: "Please enter the verification code",
        codeError: "Please enter the correct verification code",
        code: "Code",
        send: "Send Code",
        sendSuccess: "Sent Successfully",
        confirm: "Confirm",
    },

    wechat: {
        noBind: "Not Bound",
        alreadyBind: "Already Bound",
        bindTip:
            "Open WeChat and scan the QR code to follow the official account automatically.<br>Important messages will be pushed via WeChat.",
        cancelBind: "Unbind",
        unbind_confirm: "Are you sure you want to unbind?",
    },
};
